<widget data-testid="matching-vcc-widget" title="VCC Matching" [subTitle]="'Shows the distribution of matched  and unmatched VCCs.'+ (dateFilterText | async)">
  <div id="matching-vcc-chart-wrap" class="widget-chart-wrap" widgetContent>
    <div *ngIf="isLoading" id="matching-vcc-loading" class="loading-container">
      <mat-spinner diameter="30"></mat-spinner>
      <span>Loading chart data...</span>
    </div>

    <div *ngIf="isError && !isLoading" id="matching-vcc-error" class="error-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>

    <chart *ngIf="!isLoading && !isError && dataMatching && dataMatching.labels && dataMatching.labels.length > 0" id="matching-vcc-chart"
      [dataSet]="dataMatching"
      [chartType]="'bar'"
      (chartClick)="navigateToReport($event)"
      [options]="matchingVccChartOptions">
    </chart>

    <div *ngIf="!isLoading && !isError && (!dataMatching || !dataMatching.labels || dataMatching.labels.length === 0)" id="matching-vcc-empty" class="empty-container">
      <mat-icon>info</mat-icon>
      <span>No data for the chosen parameters.</span>
    </div>
  </div>
</widget>